module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_10X_WTA.c26bb5f9.png";